// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__19X8B","title":"ClientReferral_title__36RDT","itemText":"ClientReferral_itemText__2uoRV"};